/**
 * Utilitário para adicionar animação de "pulando" (bounce) em ícones SVG.
 * Usado nos marcadores quando estão em modo de mover.
 */

/**
 * Envolve o conteúdo de um SVG com animação de salto (translate Y).
 * Retorna a data URL com o SVG animado.
 */
export function wrapSvgWithBounceAnimation(svgDataUrl: string): string {
  try {
    const encoded = svgDataUrl.replace(/^data:image\/svg\+xml(?:;charset=UTF-8)?,/, '');
    const svgString = decodeURIComponent(encoded);
    const openTagEnd = svgString.indexOf('>', svgString.indexOf('<svg'));
    if (openTagEnd === -1) return svgDataUrl;

    const openTag = svgString.substring(0, openTagEnd + 1);
    const content = svgString.substring(openTagEnd + 1, svgString.lastIndexOf('</svg>'));
    const closeTag = '</svg>';

    const animatedContent =
      '<g>' +
      '<animateTransform attributeName="transform" type="translate" values="0 0;0 -6;0 0" dur="0.6s" repeatCount="indefinite"/>' +
      content +
      '</g>';

    const animatedSvg = openTag + animatedContent + closeTag;
    return 'data:image/svg+xml,' + encodeURIComponent(animatedSvg);
  } catch {
    return svgDataUrl;
  }
}
